export const FREE_RESPONSE_MAX_LENGTH = 5000
